import React from "react";

const RoleBadge = ({ roleName }) => {
  return (
    <span className="badge font-weight-light badge-light">{roleName}</span>
  );
};

export default RoleBadge;
